import { Heading } from '@cinch-labs/design-system'
import styles from './store-details-wrapper.module.css'
import StoreMap from '../store-map'
import {
  StoryBlokAddress,
  StoryBlokOpeningHoursListItem,
  StoryBlokPhoneNumbers,
} from '../../types/store-page'
import { StoreDetailsList } from '../store-details-list/store-details-list'
import { addBrackets } from '../../utils/capitalise-first-letter/add-brackets/add-brackets'
import { generateStoreType } from '@cinch-nx/landing-ui-shared'

export interface StoreDetailsWrapperProps {
  slug: string
  title?: string
  latitude: number
  longitude: number
  address: StoryBlokAddress
  phoneNumbers: StoryBlokPhoneNumbers[]
  openingHours: StoryBlokOpeningHoursListItem[]
}

export const StoreDetailsWrapper = ({
  slug,
  title,
  latitude,
  longitude,
  address,
  phoneNumbers,
  openingHours,
}: StoreDetailsWrapperProps) => {
  const { addressLine1, addressLine2, townOrCity, postCode } = address
  const storeAddress = [addressLine1, addressLine2, townOrCity, postCode]
  const storeType = generateStoreType(slug)
  const sectionTitle = title ? title : `${slug} ${storeType} details`

  return (
    <div>
      <Heading id="store-details" className={styles.heading}>
        {sectionTitle}
      </Heading>
      <div className={styles.storeWrapper}>
        <div className={styles.storeDetailsSectionWrapper}>
          <StoreDetailsList icon={'location'} title="Where to find us">
            <ul className={styles.storeAddress}>
              {storeAddress.map((item) => (
                <li key={item?.toString()}>{item?.toString()}</li>
              ))}
            </ul>
          </StoreDetailsList>

          <StoreDetailsList icon={'phone'} title="Get in touch">
            <ul>
              {phoneNumbers.map((item, index) => {
                const hasPurpose = item.purpose.length > 0
                return (
                  <li key={index}>
                    {item.phoneNumber}
                    {hasPurpose && ` ${addBrackets(item.purpose)}`}
                  </li>
                )
              })}
            </ul>
          </StoreDetailsList>

          <StoreDetailsList icon={'time'} title="Opening Hours">
            <ul>
              {openingHours.map((item, index) => (
                <li className={styles.openingTimes} key={index}>
                  <span className={styles.daysOfWeek}>{item.daysOfWeek}</span>
                  {item.openingTime === 'Closed' ? (
                    <span>{item.openingTime}</span>
                  ) : (
                    <span>
                      {item.openingTime} - {item.closingTime}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </StoreDetailsList>
        </div>
        <section className={styles.map}>
          <StoreMap coordinates={[latitude, longitude]} />
        </section>
      </div>
    </div>
  )
}
